import { Website } from "../website-builder/wedding";


const defaultWebsite = new Website();

// Set any necessary properties of website here
let sixMonthsFromToday = new Date();
sixMonthsFromToday.setMonth(sixMonthsFromToday.getMonth() + 6);
let threeMonthsFromToday = new Date();
threeMonthsFromToday.setMonth(threeMonthsFromToday.getMonth() + 3);

let sixMonthsFromTodayPlusOneDay = new Date(sixMonthsFromToday);
sixMonthsFromTodayPlusOneDay.setDate(sixMonthsFromTodayPlusOneDay.getDate() + 1);
defaultWebsite.sectionOrder = [   
   'story',
'schedule',     
'rsvp',
'weddingParty',
'travel',
'registry', 
'questions',

]
defaultWebsite.defaultMode = true;
defaultWebsite.layout = 'full',
  defaultWebsite.template = 'lottie',
  defaultWebsite.colors =    
  { light: '#F5F5F5', lightAccent: '#EAE6E0', accent: '#A74D4A', darkAccent: '#818B7E', dark: '#121212' },
  defaultWebsite.colorsMinimalTemplateDefault = {
    light: '#FAFAD2',
    dark: '#FF4500',

  };
defaultWebsite.fonts = {
  heading: 'Inter Variable',
  paragraph: 'Inter Variable',
  misc: 'Inter Variable'
};
defaultWebsite.rsvp = {
  sectionNameTextTranslation: '',
  isEnabled : true,
  sectionName: 'RSVP',
}
defaultWebsite.style = 'minimal';
defaultWebsite.weddingEvents = [
  {
    address: '49-560 Kamehameha Hwy, Kaneohe, HI',
    startDate: sixMonthsFromToday,
    startDateUtc: null,
    description: 'We\'re exchanging vows surrounded by the breathtaking views of Paliku Gardens. Join us as we begin this next chapter together.',
    endTime: '1:00 PM',
    eventName: 'Wedding Day',
    startTime: '10:00 PM',
    venue: 'Paliku Gardens',
    attire: 'Semi-Formal',
    collectRsvpsOnWebsite: true,
    attendanceQuestion: {
      id: "wedenv_rsvp" + new Date().getTime().toString() + 1,
      question: 'Will you be attending our wedding?',
      questionType: 'multi select',
      options: ['Yes', 'No'],
      optionsTranslation: [],
      optional: false,
      questionTranslation: ''

    }
    ,    rsvpQuestions: [

     
    ],
    createdDate: null,
    modifiedDate: null,
    id: "wedenv-" + new Date().getTime().toString() + 3,
    endDate: sixMonthsFromTodayPlusOneDay,
    endDateUtc: null,
    isPrivate: false,
    addressTranslation: '',
    attireTranslation: '',
    descriptionTranslation: '',
    eventNameTranslation: '',
    venueTranslation: ''
  },
  
 
];


defaultWebsite.welcome = {
  heroImageUrl: '',
  eventEndDate: null,
  eventEndDateUtc: null,
  sectionName: 'Welcome',
  eventDisplayName: 'Zoe and Noah from default-data Lottie',
  greetings: 'Welcome to our wedding from default data Lottie',
  eventDate: sixMonthsFromToday,
  eventDateUtc: null,
  eventLocation: '742 Evergreen Terrace, Springfield',
  isEnabled: true,
  heroImageUrlEnabled : true,
  eventDisplayNameTranslation: '',
  greetingsTranslation: '',
  rsvpDeadline: threeMonthsFromToday,
  rsvpDeadlineDateUtc: null,
  rsvpShortNote: 'Please RSVP by',
  rsvpShortNoteTranslation: '',
  updated: false
   
};
defaultWebsite.story = {
  sectionName: 'Story',
  sectionNameTranslation: '',
  storyText: 'Zoe LottieLottie and Noah met in college, and have been inseparable ever since. They love to travel, and have been to 10 countries together. They are excited to start their life together, and can’t wait to celebrate with you!',
  isEnabled: true,
  imageGrid: 'grid1',
  imageUrl: "https://placeholder.it/200x200", 
  imageUrl2: "https://placeholder.it/200x200",
  imageUrl3: "https://placeholder.it/200x200",
  imageUrl4: "https://placeholder.it/200x200",
  imageUrl5: '/assets/public/images/website-templates/celine-story-grid-5.jpg',
  imageUrl6: '/assets/public/images/website-templates/celine-story-grid-6.jpg',
  imageEnabled: true,
  storyTextTranslation: '',
  storyHighlight: 'Zoe and LottieLottie Noah met in college, and have been inseparable ever since. They love to travel, and have been to 10 countries together. They are excited to start their life together, and can’t wait to celebrate with you!',
  storyHighlightTranslation: '',
  updated: false

};
defaultWebsite.announcement = {
  headline: 'Important Notice',
  sectionName: 'Announcement',
  message: 'Contact the Maid of Honor for any questions if you are unable to contact us on the day of the wedding',
  isEnabled: false,
  headlineTranslation: '',
  messageTranslation: '',
  

};
defaultWebsite.schedule = {
  sectionNameTranslation: '',
  updated: false,
  scheduleItems: [
    {
      eventName: 'Ceremony',
      startDate: sixMonthsFromToday,
      startTime: '3:00 PM',
      endTime: '3:30 PM',
      endDate: sixMonthsFromToday,
      venue: 'Simpsons House',
      address: '742 Evergreen Terrace, Springfield',
      attire: 'Formal',
      description: 'The ceremony will be held in the backyard of the Simpson’s house. Please arrive 15 minutes early to find your seat.',
addressTranslation: '',
attireTranslation: '',
startDateUtc: null,
endDateUtc: null,
descriptionTranslation: '',
eventNameTranslation: '',
venueTranslation: ''
    },
    {
      eventName: 'Reception',
      startDate: sixMonthsFromToday,
      startTime: '4:00 PM',
      endTime: '8:00 PM',
      endDate: sixMonthsFromToday,
      venue: 'Simpsons House',
      address: '742 Evergreen Terrace, Springfield',
      attire: 'Formal',
      startDateUtc: null,
      endDateUtc: null,
      description: 'The reception will be held in the backyard of the Simpson’s house. Please arrive 15 minutes early to find your seat.',
      addressTranslation: '',
attireTranslation: '',
descriptionTranslation: '',
eventNameTranslation: '',
venueTranslation: ''
    },
  ],
  sectionName: 'Schedule',
  isEnabled: true,
};
defaultWebsite.weddingParty = {
  sectionNameTranslation: '',
  introTranslation: '',
  intro: '',
  partyMembers: [
    {
      firstName: 'Homer',
      lastName: 'Simpson',
      role: 'Father of the Bride Lottie',
      imageUrl: 'https://vignette.wikia.nocookie.net/simpsons/images/8/84/Homer_Simpson_2006.png/revision/latest?cb=20121203210829',
      story: 'Homer is the father of the bride. He is a loving father, and is excited to give his daughter away to Noah.',
      email: 'homer@theplant.com',
      phone: '555-555-5555',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'Marge',
      lastName: 'Simpson',
      role: 'Mother of the Brid Lottie',
      imageUrl: 'https://vignette.wikia.nocookie.net/simpsons/images/2/2e/Marge_Simpson.png/revision/latest?cb=20180320022845',
      story: 'Marge is the mother of the bride. She is a loving mother, and is excited to give her daughter away to Noah.',
      email: 'marge@simpsons.com',
      phone: '555-555-5555',
      roleTranslation: '',
      storyTranslation: ''
    }, {
      firstName: 'Milhouse',
      lastName: 'Van Houten',
      role: 'Best man',
      imageUrl: 'https://vignette.wikia.nocookie.net/simpsons/images/2/2e/Marge_Simpson.png/revision/latest?cb=20180320022845',
      story: 'Milhouse is Lottie ',
      email: 'trillhouse@bloodstorm.com',
      phone: '555-555-5555',
      roleTranslation: '',
      storyTranslation: ''
    },
    {
      firstName: 'Lisa',
      lastName: 'Simpson Lottie',
      role: 'Bridesmaid',
      imageUrl: 'https://vignette.wikia.nocookie.net/simpsons/images/2/2e/Marge_Simpson.png/revision/latest?cb=20180320022845',
      story: 'Milhouse is xxxxxxxx',
      email: 'trillhouse@bloodstorm.com',
      phone: '555-555-5555',
      roleTranslation: '',
      storyTranslation: ''
    }
  ],
  sectionName: 'Wedding Party',
  isEnabled: true,
};
defaultWebsite.travel = {
  travelInfo: [],
  sectionName: 'Travel Guide',
  isEnabled: true,
  sectionNameTranslation: '',
};
defaultWebsite.questions = {
  sectionNameTranslation: '',
  questions: [
    {
      title: 'What is the dress code?',
      text: 'The dress code is formal. Please wear your best suit or dress. Lottie',
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'Is there parking available?',
      text: 'Yes, there is parking available on the street.'
      ,
      textTranslation: '',
      titleTranslation: ''
    },
    {
      title: 'What time does the ceremony start?',
      text: 'The ceremony starts at 3:00 PM.',
      textTranslation: '',
      titleTranslation: ''
    }
  ],
  sectionName: 'FAQ',
  isEnabled: true,
};
defaultWebsite.registry = {
  registryItems: null,
  isLinkedtoHitchd: true,
  sectionName: 'Registry',
  buttonText: 'Honeymoon Registry',
  buttonTextTranslation: 'Honeymoon Registry',
  isEnabled: true,
  sectionNameTranslation: '',
  
        leadInText: '',
        leadInTextTranslation: '',
};

export default defaultWebsite;


// WEBPACK FOOTER //
// ./src/app/website-template-lottie/default-data.ts